import React from "react";
import PageHeader from "@/components/PageHeader";
import Contact from "@/components/Contact";

export default function ContactPage() {
  return (
    <div data-testid="page-contact">
      <PageHeader title="Contact" />
      <Contact />
    </div>
  );
}
